// To toggle nested view in mobile
document.addEventListener("DOMContentLoaded", function() {
  const containers = document.querySelectorAll(".footer-popup-nested-view-mobile");

  containers.forEach(container => {
    const triggers = container.querySelectorAll(".footer-popup-nested-view-mobile-title");

    triggers.forEach(trigger => {
      trigger.addEventListener("click", function() {
        // If this container is already active → toggle it off
        if (container.classList.contains("active")) {
          container.classList.remove("active");
        } else {
          // Remove active from all others first
          containers.forEach(c => c.classList.remove("active"));
          // Add active to this one
          container.classList.add("active");
        }
      });
    });
  });
});
